import { render } from "./single-package-item.vue?vue&type=template&id=3ad3eb16"
import script from "./single-package-item.vue?vue&type=script&lang=js"
export * from "./single-package-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__